import PropTypes from 'prop-types';
import compose from '../hoc/compose';
import template from './panelHeaderCenteredText.jsx';
import textTypes from '../controls/textTypes';
var PanelHeaderCenteredText = template;
PanelHeaderCenteredText.displayName = 'PanelHeaderCenteredText';
PanelHeaderCenteredText.propTypes = {
  title: PropTypes.string.isRequired,
  titleType: PropTypes.oneOf(textTypes.PANEL_HEADER_CENTERED_TEXT_TITLE_TYPES),
  subtitle: PropTypes.string,
  onHelp: PropTypes.func,
  onClose: PropTypes.func
};
PanelHeaderCenteredText.defaultProps = {
  titleType: textTypes.PANEL_HEADER_CENTERED_TEXT_TITLE_DEFAULT_TYPE
};
export default compose(PanelHeaderCenteredText);